export const DEFAULT_PARTICLE_COUNT = 1024;
export const MAX_DELTA_TIME = 1 / 30; // Cap delta to prevent large jumps
export const POINT_SIZE_MULTIPLIER = 300.0; // Used in vertex shader for point size calculation

